export const MAX_FORM_SESSION_ITEMS = 10_000;

export const FORMATTED_MAX_FORM_SESSION_ITEMS = new Intl.NumberFormat('en-US').format(MAX_FORM_SESSION_ITEMS);
